import React from 'react';
import { Globe, ExternalLink, Check } from 'lucide-react';
import type { Site } from './types';

interface StatsCardsProps {
  sites: Site[];
}

export const StatsCards: React.FC<StatsCardsProps> = ({ sites }) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
    <div className="card p-6">
      <div className="flex items-center">
        <div className="p-3 rounded-full bg-blue-100">
          <Globe className="h-6 w-6 text-blue-600" />
        </div>
        <div className="ml-4">
          <p className="text-sm font-medium text-gray-600">Total Sites</p>
          <p className="text-2xl font-bold text-gray-900">{sites.length}</p>
        </div>
      </div>
    </div>

    <div className="card p-6">
      <div className="flex items-center">
        <div className="p-3 rounded-full bg-green-100">
          <ExternalLink className="h-6 w-6 text-green-600" />
        </div>
        <div className="ml-4">
          <p className="text-sm font-medium text-gray-600">Custom Domains</p>
          <p className="text-2xl font-bold text-gray-900">
            {sites.filter(s => s.customDomain).length}
          </p>
        </div>
      </div>
    </div>

    <div className="card p-6">
      <div className="flex items-center">
        <div className="p-3 rounded-full bg-purple-100">
          <Check className="h-6 w-6 text-purple-600" />
        </div>
        <div className="ml-4">
          <p className="text-sm font-medium text-gray-600">Published Sites</p>
          <p className="text-2xl font-bold text-gray-900">
            {sites.filter(s => s.isPublished).length}
          </p>
        </div>
      </div>
    </div>
  </div>
);
